<script>
import TempalteSelector from './TempalteSelector.vue'
import { loadSchemasByType } from '@/api/schema'
import nodeID from '@/mixins/nodeID'
import schema from '@/mixins/schema'

export default {
  name: 'SchemasSelector',

  extends: TempalteSelector,

  props: {
    type: { type: String, default: '' }, // protobuf | custom
  },

  mixins: [nodeID, schema],

  watch: {
    type: {
      immediate: true,
      handler() {
        this.init()
      },
    },
  },

  methods: {
    getList() {
      if (!this.type) {
        return this.getSchemaList(this.nodeID)
      }
      return new Promise((resolve, reject) => {
        loadSchemasByType(this.nodeID, this.type)
          .then((res) => {
            const data = res.data || []
            resolve(data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
}
</script>
